
export const DETAIL = {
  progress: [
    {
      step: 1,
      title: "Trưởng phòng TCNL",
      DNTitle: "Trưởng phòng KHHC-Đà Nẵng",
      NBTitle: "Trưởng phòng KHHC - Nội Bài",
    },
    {
      step: 2,
      title: "Tổng Giám đốc",
      NBTitle: "Giám đốc chi nhánh",
      DNTitle: "Giám đốc chi nhánh",
    },
  ],
  information: [
    {
      label: "Đơn vị",
      require: true,
      field: "unit",
      span: 12,
    },
    {
      label: "Nghiệp vụ",
      require: true,
      field: "eMajor",
      span: 12,
    },
    {
      label: "Loại hình đào tạo",
      require: true,
      field: "eTrainingType",
      span: 12,
    },
  ],
};
